<template>
  <div class="BookingsPage">
    <Navigation showPromoterNav="true"></Navigation>
    <div class="container-fluid">
      <div class="row p-t-6">
        <div class="p-t-2 col-md-12">
          <Card class="m-t-5">
            <div slot="title">{{t('Bookings')}}</div>
            <div slot="content">
              <input v-model="bookingCodeFilter" v-on:input="setBookingCodeFilter()" type="text" placeholder="Filter by Booking Code">

              <div class="message" v-if="bookings.length === 0">{{t('There are no bookings')}}</div>
              <table class="table" v-else>
                <thead>
                  <th>{{t('user')}}</th>
                  <th>{{t('Dates')}}</th>
                  <th>{{t('Activity')}}</th>
                  <th>{{t('Participants')}}</th>
                  <th>{{t('Status')}}</th>
                  <th>{{t('Price')}}</th>
                </thead>
                <tbody>
                  <tr v-for="(booking, index) in bookings" class="booking" v-bind:class="{rejected: (booking.state_id === 4), hasHappened: hasHappened(booking.date)}">
                    <td>
                      {{booking.user.name}}<br/>
                      {{booking.user.email}}<br/>
                      {{booking.user.phone}}

                    </td>
                    <td class="dates">
                      created: <b>{{toNow(booking.created_at)}}</b> ago<br/>
                      occurs at: <b>{{booking.date}}</b> (in {{toNow(booking.date)}})
                    </td>
                    <td>
                      <router-link class="bookingCode" :to="`/${language}/bookings/${booking.booking_code}`">{{booking.booking_code}}
                      </router-link><br/>
                      <div class="promotionalCode" v-if="booking.promotional_code !== null"><i class="fa fa-ticket"></i> <b>promo code:</b> {{booking.promotional_code}}</div>
                      {{booking.activity.translations[language].name}}
                  </td>
                    <td>{{booking.persons.length}}</td>
                    <td>{{t(booking.state)}}</td>
                    <td>{{booking.total_price}} €
                      <span v-if="booking.state_id === 3">
                        <small v-if="booking.to_be_charged">
                          <span v-if="!hasHappened(booking.date)">({{t('Will be charged')}})</span>
                          <span v-else>({{t('Has been charged')}})</span>
                        </small>
                        <small v-else>
                          ({{t('Will not be charged')}})
                        </small>
                      </span>

                    </td>
                    <td>
                      <button class="btn btn-primary" v-if="!booking.to_be_charged" @click="willBePaidLocal({booking_code: booking.booking_code, to_be_charged: true})">cobrar</button>
                      <button class="btn btn-primary" v-else @click="willBePaidLocal({booking_code: booking.booking_code, to_be_charged: false})">não cobrar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment-mini';
import Navigation from '../Admin/Navigation/Navigation';
import Card from '../Card';
import formatTime from '../../lib/formatTime';


export default {
  name: 'AdminBookings',
  components: { Navigation, Card },
  data() {
    return {
      bookingCodeFilter: '',
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      bookings: state => state.adminBookings.filteredData,
    }),
  },
  methods: {
    ...mapActions({
      getBookings: 'adminBookings/get',
      willBePaid: 'adminBookings/willBePaid',
    }),
    setBookingCodeFilter() {
      this.$store.dispatch('adminBookings/setBookingCodeFilter', this.bookingCodeFilter);
    },
    canCancel(booking) {
      if (booking.state_id === 4 || booking.state_id === 3) {
        return false;
      }
      if (this.hasHappened(booking.date)) {
        return false;
      }
      return true;
    },
    hasHappened(dateTime) {
      return moment(dateTime).diff(moment()) < 0;
    },
    humanTime(dateTime) {
      return formatTime.longWithTime(dateTime, this.language);
    },
    toNow(dateTime) {
      return formatTime.toNow(dateTime);
    },
    willBePaidLocal(payload) {
      this.willBePaid(payload).then(() => {
        this.getBookings();
      });
    },
  },
  mounted() {
    this.getBookings();
  },
};

</script>


<style lang="scss" scoped>
.BookingsPage {
  min-height: 100vh;
}
.table td {
  font-size: 13px;
  font-wieght: 500;
}

.bookingCode {
  margin-left: 0;
}

.promotionalCode {
  color: #bb2222;
}
</style>



// WEBPACK FOOTER //
// AdminBookings.vue?046e22be